export default "__VITE_PUBLIC_ASSET__35ea909f__"